/// <reference path="../../css.d.ts" />
// @ubm/ui/components/button — CLASSES de la peinture canonique, SERVER-SAFE (lot U1, 05/10/2026).
// Aucune directive client, aucun Motion : une fonction pure appelable en RSC (ex. `@ubm/product-ui` `buttonVariants` pour un
// `<Link className=…>` serveur). C'est la MÊME source de classes que `ButtonCore` (qui l'appelle) : variante, taille, accent de
// marque, forme, plus la classe `ubm-ui-canon` qui retire le nœud des anciennes peaux (native-fields-apple, product styles)
// quand l'attribut interne `data-ubm-canon` ne peut pas être posé (balisage brut d'un helper). La motion (pression, morph,
// chargement) n'existe que dans le renderer client : un appelant qui la veut rend `Button` (ex. `asChild` autour d'un lien).
// Fondation UIArc embarquée (jetons --arc-*).
import "../../styles/foundation.css";
import styles from "./button.module.css";

export type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";
export type ButtonSize = "xs" | "sm" | "md" | "lg" | "xl";

export interface ButtonCanonClassOptions {
  variant?: ButtonVariant;
  size?: ButtonSize;
  accent?: boolean;
  shape?: "pill" | "icon";
}

export function buttonCanonClassName({ variant = "primary", size = "md", accent = false, shape }: ButtonCanonClassOptions = {}): string {
  return [styles.button, styles[variant], styles[size], accent ? styles.accent : "", shape ? styles[shape] : "", "ubm-ui-canon"]
    .filter(Boolean)
    .join(" ");
}
